// ✅ US Market Hosting - Thin Wrapper (DRY principle)
import HostingPage from '../../sub/hosting';
import SEOHead from '../../../components/SEOHead';

export default function USHosting() {
  return (
    <>
      <SEOHead
        title='Web Hosting | LBVisible'
        description='Reliable and fast web hosting services for your website.'
        keywords='web hosting USA, website hosting, cloud hosting'
        canonicalUrl='/us/sub/hosting'
        lang='en'
        hreflang={[
          { hreflang: 'en-GB', href: 'https://www.lbvisible.com/sub/hosting' },
          { hreflang: 'en-US', href: 'https://www.lbvisible.com/us/sub/hosting' },
          { hreflang: 'lt-LT', href: 'https://www.lbvisible.com/lt/sub/hostingas' },
          { hreflang: 'x-default', href: 'https://www.lbvisible.com/sub/hosting' },
        ]}
      />

      <HostingPage />
    </>
  );
}
